"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var getters = {
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  device: function device(state) {
    return state.app.device;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  deviceNameObj: function deviceNameObj(state) {
    return state.user.deviceNameObj;
  },
  deviceKeyObj: function deviceKeyObj(state) {
    return state.user.deviceKeyObj;
  },
  agentDevice: function agentDevice(state) {
    return state.user.agentDevice;
  },
  siteInfo: function siteInfo(state) {
    return state.user.siteInfo;
  },
  agentInfo: function agentInfo(state) {
    return state.user.agentInfo;
  },
  rests: function rests(state) {
    return state.rests;
  },
  needForceChangePassword: function needForceChangePassword(state) {
    return state.user.needForceChangePassword;
  }
};
var _default = exports.default = getters;